export default __webpack_public_path__ + "static/media/empty-placeholder.cd35960a.png";